/**
 * Convert JSX element to string
 * @param {any} element - JSX element or any object
 * @returns {string} - String representation of the element
 */
export default function convertJsxToString(element) {
  // Handle JSX elements with dangerouslySetInnerHTML
  if (element.props?.dangerouslySetInnerHTML?.__html) {
    return element.props.dangerouslySetInnerHTML.__html;
  }

  // Handle JSX elements with children text
  if (element.props && typeof element.props.children === 'string') {
    return element.props.children;
  }

  // Handle React elements using toString if available
  if (element.toString && typeof element.toString === 'function') {
    const stringResult = element.toString();
    // Only use toString result if it's not the default [object Object]
    if (stringResult !== '[object Object]') {
      return stringResult;
    }
  }

  // Fallback: return empty string for objects we can't convert
  return '';
}
